var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AddonPromo',{attrs:{"title":_vm.$t('common.public-api'),"text":_vm.$t('addons.public-api'),"image-src":"/images/public-api.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }